/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Moment from 'moment';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Footer.scss';

class Footer extends React.Component {
  render() {
    const currentYear = Moment().year();
    return (
      <div className={s.root}>
        <div className={s.container}>
          <p className={s.text}>
            <span>{currentYear} © Right2Water </span>
            <span>
              <a href="//www.epsu.org/">epsu.org</a>{' '}
            </span>
            <span>
              Site by <a href="//www.tiltfactory.com/">Tilt Factory</a>
            </span>
          </p>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Footer);
